import store from '../../store'
import { getSdkCDNFromIframe } from '../utils'
import { cookieConstant } from '../constants'
import { getCookieForLogs } from '../cookie'
import { sendLogsToDatadog } from '../logger'
import Storage from '../storageLib'

export default class LogsErrorsBlueprint {
    constructor({ name = null, message = null, ...rest}) {
        this.name = name || this.constructor.name
        this.message = message || 'Something bad happened'
        this.extraLogProperties = rest
        const SDK_CDN = getSdkCDNFromIframe()
        const widgetEndPoint = SDK_CDN !== '' ? new URL(SDK_CDN).hostname : '/'
        this.mandatoryLogProperties = {
            errorOrigin: 'NETOMI',
            botRefId: store?.state?.botRefId, 
            conversationId: getCookieForLogs(cookieConstant.SESSION.CONVERSATION_ID),
            domainURL: window.parent.location.hostname,
            href: window.parent.location?.href,
            hostingEndPoint: widgetEndPoint,
            userAgent: JSON.stringify(store?.state?.deviceDetails),
            internetEffectiveType: navigator?.connection?.effectiveType,
            userId: store?.state?.user?.id
        }
    }

    getLoggingProperties({ logLevel }) {
        return {
            requestBody: {
                message: this.message,
                name: this.name,
                ip: store.state.userIPAddress,
                tabId: Storage.getSessionStorageData('tabId'),
                logLevel: logLevel || 'info',
                createdAt: `${new Date(parseInt(getCookieForLogs(cookieConstant.SESSION.CREATED_AT)))}`,
                ...this.mandatoryLogProperties,
                ...this.extraLogProperties
            }
        }
    }

    sendLogs(data) {
        // Don't send errors/logs when offline
        if (!store.state?.connectionStatus) {
            return
        }
        sendLogsToDatadog(this.getLoggingProperties(data))
    }
}
